import { get } from "@/services/axiosUitils";

export interface UserRole {
  role_id: string;
  role_name: string;
}

export interface UserRoleResponse {
  success: {
    code: string;
    message: string;
  };
  user_id: string;
  roles: UserRole[];
}

const basePath = "/pts_app/user-current-role";

class UserRoleService {
  /**
   * Fetches the current roles for a user
   * @param userId - The user ID to fetch roles for
   * @returns User role information including role IDs and names
   */
  getUserCurrentRole = async (userId: string): Promise<UserRoleResponse> => {
    if (!userId) {
      throw new Error("User ID is required");
    }
    return await get<UserRoleResponse>(`${basePath}/`, {
      params: {
        user_id: userId,
      },
    });
  };
}

const instance = new UserRoleService();
export default instance;
